import { Injectable, OnDestroy } from '@angular/core';
import { TokenService } from './token.service'; // Ajustez le chemin
import { interval, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TokenCheckService implements OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    private tokenService: TokenService,
    private router: Router
  ) { }

  /**
   * Starts the periodic token validity check.
   */
  startCheckInterval(): void {
    interval(60000) // Check every 60 seconds
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.tokenService.isTokenExpired()) { 
            // valid token do nothing
        } else {
            this.tokenService.clearToken();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}